/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
import { combineReducers } from 'redux';
import { ReduxUtils } from '@spm/core';
import {
  FETCH_SD_COC_APPLICATION_FORM,
  FETCH_SD_EXTERNALUSER_COC_STATUS,
  DELETE_APPLICATION_FORM_BY_APPLICATION_FORM_ID,
} from './actionTypes';

/**
 * Updates the details in the 'UserCOC' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const fetchSdCocApplicationFormReducer = (state = {}, action) =>
  ReduxUtils.generateReducer(state, action, FETCH_SD_COC_APPLICATION_FORM);

/**
 * Updates the indicator of creation of details in the 'UserCOC' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const isFetchingFetchSdCocApplicationFormReducer = (state = {}, action) =>
  ReduxUtils.generateFetchingReducer(state, action, FETCH_SD_COC_APPLICATION_FORM);

/**
 * Updates the post data errors in the store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 */
const fetchSdCocApplicationFormErrorReducer = (state = {}, action) =>
  ReduxUtils.generateErrorReducer(state, action, FETCH_SD_COC_APPLICATION_FORM);

/**
 * Updates the details in the 'UserCOC' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const fetchSdExternaluserCocStatusReducer = (state = {}, action) =>
  ReduxUtils.generateReducer(state, action, FETCH_SD_EXTERNALUSER_COC_STATUS);

/**
 * Updates the indicator of creation of details in the 'UserCOC' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const isFetchingFetchSdExternaluserCocStatusReducer = (state = {}, action) =>
  ReduxUtils.generateFetchingReducer(state, action, FETCH_SD_EXTERNALUSER_COC_STATUS);

/**
 * Updates the post data errors in the store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 */
const fetchSdExternaluserCocStatusErrorReducer = (state = {}, action) =>
  ReduxUtils.generateErrorReducer(state, action, FETCH_SD_EXTERNALUSER_COC_STATUS);

/**
 * Updates the details in the 'UserCOC' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const deleteApplicationFormByApplicationFormIdReducer = (state = {}, action) =>
  ReduxUtils.generateReducer(state, action, DELETE_APPLICATION_FORM_BY_APPLICATION_FORM_ID);

/**
 * Updates the indicator of creation of details in the 'UserCOC' store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 * @returns the new state
 */
const isFetchingDeleteApplicationFormByApplicationFormIdReducer = (state = {}, action) =>
  ReduxUtils.generateFetchingReducer(state, action, DELETE_APPLICATION_FORM_BY_APPLICATION_FORM_ID);

/**
 * Updates the post data errors in the store object.
 *
 * @param {any} [state={}] the initial state for the reducer
 * @param {any} action the action creator
 */
const deleteApplicationFormByApplicationFormIdErrorReducer = (state = {}, action) =>
  ReduxUtils.generateErrorReducer(state, action, DELETE_APPLICATION_FORM_BY_APPLICATION_FORM_ID);

const reducers = combineReducers({
  fetchSdCocApplicationForm: fetchSdCocApplicationFormReducer,

  isFetchingFetchSdCocApplicationForm: isFetchingFetchSdCocApplicationFormReducer,
  fetchSdCocApplicationFormError: fetchSdCocApplicationFormErrorReducer,

  fetchSdExternaluserCocStatus: fetchSdExternaluserCocStatusReducer,

  isFetchingFetchSdExternaluserCocStatus: isFetchingFetchSdExternaluserCocStatusReducer,
  fetchSdExternaluserCocStatusError: fetchSdExternaluserCocStatusErrorReducer,

  deleteApplicationFormByApplicationFormId: deleteApplicationFormByApplicationFormIdReducer,

  isFetchingDeleteApplicationFormByApplicationFormId:
    isFetchingDeleteApplicationFormByApplicationFormIdReducer,
  deleteApplicationFormByApplicationFormIdError:
    deleteApplicationFormByApplicationFormIdErrorReducer,
});

export default { reducers };
